module.exports = __webpack_public_path__ + "img/sspta-icon.8d5699ef.svg";